import React, { FC } from 'react';
import classNames from 'classnames/bind';

import { Accumulator } from './Accumulator';
import styles from './styles.pcss';
import { AccumulatorsProps } from '../../types';

const cn = classNames.bind(styles);

export const Accumulators: FC<AccumulatorsProps> = ({
  accumulators,
  buyTrafficText,
  tariffUrl,
  className,
}) => (
  <div className={className}>
    <ul className={cn('list', { byTwo: accumulators && accumulators.length < 3 })}>
      {accumulators?.map((accumulator) => (
        <li className={cn('list-item')} key={accumulator.unit}>
          <Accumulator {...accumulator} buyTrafficText={buyTrafficText} tariffUrl={tariffUrl} />
        </li>
      ))}
    </ul>
  </div>
);
